import { useQuery, UseQueryResult } from 'react-query';
import { ITournament } from '../types/ITournament';
import { getTournaments, ITournamentsParams } from '../api/tournament';

interface IUseGetTournamentsListResponse {
    total: number;
    entities: ITournament[];
}

export function useGetTournamentsList(
    params: ITournamentsParams
): UseQueryResult<IUseGetTournamentsListResponse> {
    return useQuery(['tournamentsList', params.active], () => getTournaments(params), {
        retry: false,
        staleTime: Infinity,
        cacheTime: 100,
    });
}
